
export class Message {
    id: number;
    chat_id: number;
    reply_to: number;
    send_at: any;
    read_at: any;
    agent_json: any;
    client_json: any;
    message: string;
    name: string;
    file: string;
    agent_id: number;
    client_id: number;

    setFromApiModel(apiModel: any): this {
        this.id = apiModel.id;
        this.chat_id = apiModel.chat_id;
        this.reply_to = parseInt(apiModel.reply_to);
        this.send_at = apiModel.send_at;
        this.read_at = apiModel.read_at;
        this.agent_json = JSON.parse(apiModel.agent_json);
        this.client_json = JSON.parse(apiModel.client_json);
        this.message = apiModel.message;
        this.file = apiModel.file;
        this.name = apiModel.name;
        this.agent_id = apiModel.agent_id;
        this.client_id = apiModel.client_id;
        return this;
    }
}
